<template>
  <div class="weapp">
    <div class="weapp-main" :style="{ height: screenHeight + 'px' }">
      <div class="weapp-left">
        <img
          src="@/assets/images/phone_img.png"
          :style="{ height: screenHeight + 'px' }"
        />
      </div>
      <div class="weapp-right">
        <p class="weapp-name">内推圈，一个有温度的圈子、靠谱真需求</p>
        <p>专为回蓉，跳槽而生的本土化招聘平台</p>
        <div class="QR-code">
          <div class="QR-code-list">
            <img src="../../assets/images/qr_code_wxx.jpg" />
            <p>扫码进入小程序<br />手机求职更简单</p>
          </div>
          <div class="QR-code-list">
            <img src="../../assets/images/qr_code_wxg.jpg" />
            <p>扫码关注微信公众号序<br />手机求职更简单</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "weapp",
  data() {
    return {};
  },
  created() {
    console.log(document.body.clientHeight - 157);
  },
  computed: {
    screenHeight() {
      return document.body.clientHeight - 157;
    }
  }
};
</script>

<style lang="less" scoped>
.weapp {
  width: 100%;
  background: #049cfd;
  // padding-top: 80px;
  box-sizing: border-box;
  margin-top: 56px;
  &-main {
    width: 1200px;
    margin: auto;
    // height: 880px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &-left {
    width: 600px;
    img {
      display: block;
      // height: 880px;
    }
  }
  &-right {
    font-size: 18px;
    color: #fff;
    text-align: center;
    .weapp-name {
      font-size: 42px;
      margin-bottom: 22px;
    }
  }
  .QR-code {
    display: flex;
    margin-top: 100px;
    &-list {
      &:first-of-type {
        margin-right: 40px;
      }
      img {
        display: block;
        width: 234px;
        margin-bottom: 20px;
      }
      p {
        line-height: 28px;
      }
    }
  }
}
</style>
